export function invariant(cond, message) {
    if (!cond) {
        throw new Error(`[serializr] ${message || 'Illegal State'}`);
    }
}
export function isPrimitive(value) {
    if (value === null)
        return true;
    return !['object', 'function'].includes(typeof value);
}
export function isModelSchema(thing) {
    return !!thing && !!thing.props;
}
export function isPropSchema(thing) {
    return !!thing && !!thing.serializer && !!thing.deserializer;
}
export function isAliasedPropSchema(propSchema) {
    return typeof propSchema === 'object' && !!propSchema.jsonname;
}
export function isMapLike(thing) {
    return thing && typeof thing.keys === 'function' && typeof thing.clear === 'function';
}
export function carefullyReplaceByArray(target, source) {
    for (let i = 0; i < source.length; i++) {
        if (target[i] !== source[i]) {
            target[i] = source[i];
        }
    }
    for (let i = source.length; i < target.length; i++) {
        delete target[i];
    }
    return target;
}
